export default "__VITE_ASSET__beb8684b__"